import styled from 'styled-components'

export const Content = styled.div`
  max-width: 500px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`
